// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b1ff7a8d","239":"a0efede6","732":"8c17cdf1"}[chunkId] + ".chunk.js";
};